/**
 * v77.99.10 — Centralised pricing constants/copy. Mirrors the values
 * surfaced by `GET /api/subscription/config` so we never drift between
 * marketing copy and the backend's source of truth.
 *
 * To change pricing in production, update the Stripe Price (admin
 * dashboard) AND these constants in lockstep.
 *
 * v77.99.21 — NEW CODE should prefer the `usePlans` hook from
 * `@/lib/usePlans` so the strings are hydrated live from the backend
 * `GET /api/billing/plans` endpoint. These constants remain as
 * safe fallbacks for components that render outside a React tree
 * (PDF generators, email templates, FAQs assembled at module init).
 */

export const MONTHLY_PRICE_EUR = 10.99;
export const YEARLY_PRICE_EUR = 99.0;
export const MIN_MONTHS = 3;
export const TRIAL_DAYS = 7;

// Derived totals — kept here so the same numbers can be reused by
// Pricing.jsx, UpgradePrompt, FAQs, T&Cs, and emails.
export const MONTHLY_MIN_TOTAL = (MONTHLY_PRICE_EUR * MIN_MONTHS).toFixed(2); // 32.97
export const YEARLY_MONTHLY_EQUIV = (YEARLY_PRICE_EUR / 12).toFixed(2);        // 8.25
export const YEARLY_SAVINGS_EUR = (
  MONTHLY_PRICE_EUR * 12 - YEARLY_PRICE_EUR
).toFixed(2);                                                                  // 32.88
export const YEARLY_SAVINGS_PCT = Math.round(
  ((MONTHLY_PRICE_EUR * 12 - YEARLY_PRICE_EUR) / (MONTHLY_PRICE_EUR * 12)) * 100,
);                                                                              // 25

// Canonical labels used across all surfaces.
export const PLAN_LABEL = {
  monthly: "Monthly",
  yearly: "Yearly",
};

export const formatPriceForInterval = (interval) =>
  interval === "yearly"
    ? `€${YEARLY_PRICE_EUR.toFixed(2)} / year`
    : `€${MONTHLY_PRICE_EUR.toFixed(2)} / month`;
